import React, { useEffect } from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./DoctorDetailModal.module.css";

// icons
// import closeIcon from "../../../images/icons/close.svg";

const DoctorDetailModal = ({ doctor, isOpen, onClose }) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  // Close on ESC key
  useEffect(() => {
    const handleEsc = event => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEsc);
    }

    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !doctor) return null;

  const handleOverlayClick = () => {
    onClose();
  };

  const handleOverlayKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      onClose();
    }
  };

  return (
    <div
      className={styles.modalOverlay}
      onClick={handleOverlayClick}
      onKeyDown={handleOverlayKeyDown}
      role="button"
      tabIndex={0}
      aria-label="Close modal"
    >
      <div
        className={styles.modalContent}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="doctor-modal-title"
      >
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
        >
          Close
          <span className={`icon-cross ${styles.closeIcon}`}></span>
        </button>

        <div className={styles.modalBody}>
          <div className={styles.doctorImageSection}>
            <div
              className={styles.doctorImageWrapper}
              style={{ backgroundColor: doctor.bgColor }}
            >
              <div className={styles.doctorImage}>{doctor.detailImage}</div>
            </div>
            <div className={styles.doctorInfo}>
              <h2 id="doctor-modal-title" className={styles.doctorName}>
                {doctor.name}
              </h2>
              <p className={styles.doctorCredentials}>{doctor.credentials}</p>
            </div>
          </div>

          <div className={styles.divider}></div>

          <div className={styles.doctorDetails}>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Specialization:</span>
              <span className={styles.detailValue}>
                {doctor.specialization}
              </span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Location:</span>
              <span className={styles.detailValue}>{doctor.location}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Experience:</span>
              <span className={styles.detailValue}>{doctor.experience}</span>
            </div>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Patients Treated:</span>
              <span className={styles.detailValue}>
                {doctor.patientsTreated}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DoctorDetailModal.propTypes = {
  doctor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    experience: PropTypes.string.isRequired,
    credentials: PropTypes.string.isRequired,
    bgColor: PropTypes.string.isRequired,
    specialization: PropTypes.string.isRequired,
    location: PropTypes.string.isRequired,
    patientsTreated: PropTypes.string.isRequired,
    detailImage: PropTypes.node.isRequired,
  }),
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DoctorDetailModal;
